import { translateSingle, translateBatch } from "@/api/live";
/**
 * 对象转为 query string
 * @param params 参数对象
 * @returns 查询字符串
 */
export function toQueryString(params: Record<string, any> = {}) {
  return Object.entries(params)
    .filter(([_, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

import FingerprintJS from "@fingerprintjs/fingerprintjs";
export async function getFingerprint() {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  return result; // 唯一ID
}

/**
 * 单次翻译
 */
export async function translateSingleText(text: string, targetLang: string) {
  const res = await translateSingle({
    text,
    targetLang
  });
  return res;
}

/**
 * 批量翻译
 */
export async function translateBatchText(texts: string[], targetLang: string) {
  const res = await translateBatch({
    texts,
    targetLang
  });
  return res;
}
